import typeahead from './components/articleSearchBoxHandler';

export default typeahead;